import { createSlice } from "@reduxjs/toolkit";

const data = {
    tiposVinculaciones: [{ id: 0, descripcion: "" }],
    personaVinculaciones: [{
        id: 0,
        idPersona: 0,
        numero: 0,
        idPersonaVinculo: 0,
        idTipoVinculo: 0,
        personaVinculo: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    }],
}

export const personBondingSlice = createSlice({
    name: "personBonding",
    initialState: {},
    reducers: {
        initPersonBonding: (state, action) => {
            const { sliceKey } = action.payload;
            if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
        },
        setTiposVinculaciones: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].tiposVinculaciones = data;
        },
        setPersonaVinculaciones: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].personaVinculaciones = data;
        },
        setDatoPersonaVinculaciones: (state, action) => {
            var { sliceKey, numero, name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            const index = state[sliceKey].personaVinculaciones.findIndex(item => item.numero === numero);
            state[sliceKey].personaVinculaciones[index][name] = value;
        },
        addPersonaVinculaciones: (state, action) => {
            var sliceKey = action.payload;
            var maxNumero = state[sliceKey].personaVinculaciones.length === 0 ? 0 : Math.max.apply(null, state[sliceKey].personaVinculaciones.map((item) => { return item.numero; }))

            state[sliceKey].personaVinculaciones.push(defaultPersonaVinculaciones.map((item) => { return { ...item, numero: maxNumero + 1 } })[0]);
        },
        removePersonaVinculaciones: (state, action) => {
            const { sliceKey, numero } = action.payload;
            state[sliceKey].personaVinculaciones = state[sliceKey].personaVinculaciones.filter(item => item.numero !== numero)
        },
    },
});

export const { initPersonBonding, setTiposVinculaciones, setPersonaVinculaciones, setDatoPersonaVinculaciones
    , addPersonaVinculaciones, removePersonaVinculaciones } = personBondingSlice.actions;
export const defaultPersonaVinculaciones = [{
    id: 0,
    idPersona: 0,
    numero: 0,
    idPersonaVinculo: 0,
    idTipoVinculo: 0,
    personaVinculo: "",
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
}]
export default personBondingSlice.reducer;
